import type { Dispatch, SetStateAction } from 'react';
import { SelectedEstimateOption } from '@/types/estimates/SelectedEstimateOptionType';

export type CircuitBookingPreviewState = {
  nbAdults: number;
  nbChildren: number;
  nbAdolescents: number;
  childrenBirthDates: Record<number, Date>;
  selectedOptions: Record<string, SelectedEstimateOption>;
  setNbAdults: (updater: (value: number) => number) => void;
  setNbChildren: (updater: (value: number) => number) => void;
  setChildrenBirthDates: (
    updater: (value: Record<number, Date>) => Record<number, Date>,
  ) => void;
  setSelectedOptions: Dispatch<
    SetStateAction<Record<string, SelectedEstimateOption>>
  >;
};

export const getCircuitBookingPreviewKey = ({
  nbAdults,
  nbChildren,
  nbAdolescents,
  childrenBirthDates,
  selectedArrivalDate,
}: {
  nbAdults: number;
  nbChildren: number;
  nbAdolescents: number;
  childrenBirthDates: Record<number, Date>;
  selectedArrivalDate?: Date;
}) =>
  JSON.stringify({
    nbAdults,
    nbChildren,
    nbAdolescents,
    birthDates: Object.entries(childrenBirthDates)
      .toSorted(([a], [b]) => Number(a) - Number(b))
      .map(([index, date]) => [index, date.toISOString()]),
    arrival: selectedArrivalDate?.toISOString() ?? null,
  });
